import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import SearchQuery from '../models/search-query';
var DEFAULT_SERVER_ENDPOINT = 'http://localhost:9002/svc/search';
var DEFAULT_CLIENT_ENDOINT = '/wsvc/search';
var emptyResponse = query => ({
  searchResults: [],
  totalHits: 0,
  numPages: 0,
  query: query.toQueryObject()
});
class SearchApiBackend {
  constructor() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isServerSide = _ref.isServerSide,
      endpoint = _ref.endpoint,
      credentials = _ref.credentials;
    this.endpoint = endpoint || (isServerSide ? DEFAULT_SERVER_ENDPOINT : DEFAULT_CLIENT_ENDOINT);
    this.isServerSide = isServerSide;
    this.credentials = credentials;
    this.isServerSide = isServerSide;
    this.getOptions = this.getOptions.bind(this);
    this.fetchListings = this.fetchListings.bind(this);
  }
  getOptions(query) {
    var queryObject = query.toQueryObject();
    var basicAuthHeader = this.credentials ? {
      headers: {
        Authorization: "Basic ".concat(this.credentials)
      }
    } : {};
    return merge({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(queryObject)
    }, this.isServerSide && basicAuthHeader);
  }
  fetchListings(listingType, query) {
    if (!(listingType && query)) {
      return Promise.reject(new Error('Listing type and query not specified'));
    }
    var searchQuery = SearchQuery.fromPossibleQueryObject(listingType, query);
    if (isEmpty(searchQuery.getLocalities()) && isEmpty(searchQuery.getBounds())) {
      return Promise.resolve(emptyResponse(searchQuery));
    }
    var requestUrl = "".concat(this.endpoint, "/").concat(listingType.pageContext);
    return fetch(requestUrl, this.getOptions(searchQuery)).then(response => {
      // eslint-disable-line no-undef
      if (!response.ok) {
        return Promise.reject(new Error("Failed to fetch listings - ".concat(response.statusText, " ").concat(response.status)));
      }
      return response.json();
    });
  }
}
export default SearchApiBackend;